var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ml-4 mb-3" }, [
    _c("div", { staticClass: "music", attrs: { id: "music" } }),
    _vm._v(" "),
    _vm.error
      ? _c("p", { staticClass: "my-4" }, [_vm._v("No se encontro el audio")])
      : _vm._e(),
    _vm._v(" "),
    _vm.audio2
      ? _c(
          "button",
          { staticClass: "btn btn-primary ml-3", on: { click: _vm.descagar } },
          [_vm._v("Descargar")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }